export const LAYER_NAMES = {
  BLOCK: 'block',
  EDIT_UNFOCUSED: 'edit:unfocused',
  EDIT_FOCUSED: 'edit:focused',
  DRAW: 'draw',
  IMAGE: 'image',
  DEBUG: 'debug',
  BOTTOM: 'bottom-layer',
  TOP: 'top-layer',
}

export const GROUP_NAMES = {
  SELECTABLE: 'selectable-group',
  TOP: 'top-group-on-layer',
  BOTTOM: 'bottom-group-on-layer',
  PORTAL_OUTER: '_outer_portal',
  PORTAL_INNER: '_inner_portal',
}
